import SyncButton from "@pathwright/web/src/modules/path/sync/SyncButton"
import { ConnectStores } from "lib/core/store"
import { DESIGN } from "path/constants"
import PathActionControls from "./PathActionControls"
import "./PathControls.css"
import PathModeControls from "./PathModeControls"

const PathControls = ({ mode, offering, disabled }) => (
  <div className="PathControls">
    <div className="PathControls__display">
      <PathModeControls />
    </div>
    <div className="PathControls__actions">
      {!disabled && <PathActionControls mode={mode} />}
      {mode && mode === DESIGN ? (
        <SyncButton
          cohortId={offering.id}
          full
          disabled={!!disabled}
        />
      ) : null}
    </div>
  </div>
)

PathControls.displayName = "PathControls"

const mapStateToProps = function (state, ownProps) {
  const { mode, path } = state.pathStore.state
  const { offering } = state.resourceStore.state

  return {
    mode,
    offering,
    path,
    ...ownProps
  }
}

const stores = [
  { store: "path", watch: ["mode", "path"] },
  { store: "resource", watch: false }
]

export default ConnectStores(PathControls, stores, {}, mapStateToProps)
